module.exports = __webpack_public_path__ + "media/images/con-ok-icon-6cdc8d1e89ebf0810018f80f0972c606.svg";